import {
  BASE_URL,
  USERS,
  USER_ONLINE_STATUS,
  CREATE_USERS,
  EDIT_USERS,
  DELETE_USERS,
  RESET_PASSWORD,
} from "../config";
import { getSessionId } from "../utils/SessionHandler";
import { handleResponse } from "./responseHandler";

export async function createUsers(userData) {
  const response = await fetch(BASE_URL + CREATE_USERS, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
    body: JSON.stringify(userData),
  });
  return handleResponse(response);
}

export async function fetchUsers(query) {
  const response = await fetch(BASE_URL + USERS + query, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
  });
  return handleResponse(response);
}

export async function fetchUserOnlineStatus(query = "") {
  const response = await fetch(BASE_URL + USER_ONLINE_STATUS + query, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
  });
  return handleResponse(response);
}

export async function fetchLoginActivity(query = "") {
  const response = await fetch(`${BASE_URL}${USERS}/login-activity${query}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
  });
  return handleResponse(response);
}

export async function fetchUserActivitySummary() {
  const response = await fetch(`${BASE_URL}${USERS}/activity-summary`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
  });
  return handleResponse(response);
}

export async function fetchUserDetails(userId) {
  const response = await fetch(`${BASE_URL}${USERS}/${userId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
  });
  return handleResponse(response);
}

export async function fetchUserSessions(userId, query = "") {
  const response = await fetch(
    `${BASE_URL}${USERS}/${userId}/sessions${query}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getSessionId()}`,
      },
    },
  );
  return handleResponse(response);
}

export async function fetchUserLoginHistory(userId, query = "") {
  const response = await fetch(
    `${BASE_URL}${USERS}/${userId}/login-history${query}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getSessionId()}`,
      },
    },
  );
  return handleResponse(response);
}

export async function forceLogoutUser(userId) {
  const response = await fetch(
    `${BASE_URL}api/v1/organisation/admin/users/${userId}/force-logout`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getSessionId()}`,
      },
    },
  );
  return handleResponse(response);
}

export async function editUsers(userData) {
  const response = await fetch(`${BASE_URL}${EDIT_USERS}${userData.id} `, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
    body: JSON.stringify(userData),
  });
  return handleResponse(response);
}

export async function deleteUsers(id) {
  const response = await fetch(`${BASE_URL}${DELETE_USERS}/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
  });
  return handleResponse(response);
}

export async function resetPassword(userId, passwordData) {
  const response = await fetch(`${BASE_URL}${RESET_PASSWORD}${userId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
    body: JSON.stringify({
      new_password: passwordData.new_password,
      confirm_password: passwordData.new_password,
    }),
  });
  return handleResponse(response);
}
